import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Alert,
} from "@themesberg/react-bootstrap";

import { reset, ResetPassword as ResetPasswordSlice } from "../../../features/profileSlice";

import {
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

const ResetPassword = () => {
  const [newData, setNewData] = useState({
    email: "",
    otp: "",
    password: "",
  });
  const { isSuccess, isLoading, data, isError, message } = useSelector(
    (state) => state.profile
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(reset());
  }, []);

  useEffect(() => {
    if (isSuccess && data?.message) {
      showSuccessDialog({
        title: "Success!",
        msg: data?.message,
      });
      navigate("/");
    } else {
      // showFailedDialog({
      //   title: "Oops!",
      //   msg: "Something went wrong with server!",
      // });
    }
  }, [data, navigate, isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(reset());
    dispatch(
      ResetPasswordSlice({
        email: newData.email,
        otp: newData.otp,
        password: newData.password,
      })
    );
  };
  return (
    <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
      <Container>
        <Row className="justify-content-center">
          <Col
            xs={12}
            className="d-flex align-items-center justify-content-center"
          >
            <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
              <div className="text-center text-md-center mb-4 mt-md-0">
                <h3 className="mb-0">Reset Password</h3>
              </div>
              {isError ? (
                <Alert variant="danger">{message?.message || message}</Alert>
              ) : null}

              <Form className="mt-4" onSubmit={handleSubmit}>
                <Form.Group id="email" className="mb-4">
                  <Form.Label>Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faEnvelope} />
                    </InputGroup.Text>
                    <Form.Control
                      autoFocus
                      required
                      type="email"
                      placeholder="email"
                      value={newData.email || ""}
                      onChange={(e) =>
                        setNewData({ ...newData, email: e.target.value })
                      }
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group>
                  <Form.Group id="otp" className="mb-4">
                    <Form.Label>OTP</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="number"
                        placeholder="OTP"
                        value={newData.otp}
                        onChange={(e) =>
                          setNewData({ ...newData, otp: e.target.value })
                        }
                      />
                    </InputGroup>
                  </Form.Group>
                </Form.Group>
                <Form.Group>
                  <Form.Group id="otp" className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        value={newData.password}
                        onChange={(e) =>
                          setNewData({ ...newData, password: e.target.value })
                        }
                      />
                    </InputGroup>
                  </Form.Group>
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={isLoading}
                >
                  Reset
                </Button>
              </Form>

              <div className="d-flex justify-content-center align-items-center mt-4">
                <span className="fw-normal">
                  Kembali ke
                  <Card.Link as={Link} to="/" className="fw-bold">
                    {` dashboard `}
                  </Card.Link>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ResetPassword;
